import { defineFieldDisplay } from "../defines";
import BooleanDisplay from "./BooleanDisplay.vue";

export default defineFieldDisplay({
  id: "boolean",
  component: BooleanDisplay,
});
